module.exports = __webpack_public_path__ + "img/53237962002926.9be60b33.png";